/**
 * Export CSV client-side PADRÃO (PO1-2724). Unifica o que Auditoria de CT-e
 * (exportDetailsToCsv) e CustomTable (handleExportCSV) faziam cada um do seu
 * jeito: célula sempre entre aspas (aspas internas duplicadas), BOM UTF-8 para
 * o Excel abrir acentos corretamente, nome com data.
 *
 * exportCsv({
 *   filename: "auditoria_cte",
 *   columns: [{ key: "Id", label: "ID" }, { label: "Valor", getValue: (r) => r.valor.toFixed(2) }],
 *   rows: lista,
 * })
 * Retorna false (e não baixa nada) quando `rows` está vazio.
 */
function normalizeColumns(columns) {
  return (columns || []).map((col) => (typeof col === "string" ? { key: col, label: col } : col));
}

function cellValue(col, row) {
  if (typeof col.getValue === "function") return col.getValue(row);
  return row ? row[col.key] : undefined;
}

export function escapeCsvCell(value) {
  const str = value === null || value === undefined ? "" : String(value);
  return `"${str.replace(/"/g, '""')}"`;
}

export function buildCsv({ columns, rows, delimiter = "," }) {
  const cols = normalizeColumns(columns);
  const header = cols.map((c) => escapeCsvCell(c.label !== undefined ? c.label : c.key)).join(delimiter);
  const lines = (rows || []).map((row) => cols.map((c) => escapeCsvCell(cellValue(c, row))).join(delimiter));
  return [header].concat(lines).join("\n");
}

export function downloadTextFile(filename, content, mime = "text/plain;charset=utf-8;") {
  const blob = new Blob([content], { type: mime });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
}

export function exportCsv({
  filename = "export",
  columns,
  rows,
  bom = true,
  dateSuffix = true,
  delimiter = ",",
}) {
  if (!rows || rows.length === 0) return false;
  const csv = buildCsv({ columns, rows, delimiter });
  const suffix = dateSuffix ? `_${new Date().toISOString().slice(0, 10)}` : "";
  downloadTextFile(`${filename}${suffix}.csv`, (bom ? "﻿" : "") + csv, "text/csv;charset=utf-8;");
  return true;
}

export default exportCsv;
